import { Component, Output, EventEmitter, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource} from '@angular/material';
import { MatCheckboxChange } from '@angular/material/checkbox';
import {HttpErrorResponse } from '@angular/common/http';
import { MessagesTitles, MessagesStatus } from '../../../models/messages';
import Swal from "sweetalert2";
import { EmpresasService } from 'app/services/empresas/empresas.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-desbloqueo-masivo',
  templateUrl: './desbloqueo-masivo.component.html',
  styleUrls: ['./desbloqueo-masivo.component.scss'],
  providers:[MessagesTitles, MessagesStatus]
})
export class DesbloqueoMasivoComponent {


  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @Output() cerrarPopupDesbloqueo= new EventEmitter<boolean>();

  dataProveedores:any= [];
  provBloqueados: any= [];
  checkboxStates = {}
  loading:boolean = false;
  datosEnviar: any=[];
  user:any;
  isLoading:boolean= false;

  displayedColumns = ['checked', 'Proveedor'];
  dataSource :any= [];

  constructor(private msgTitulos : MessagesTitles,
              private msgStatus:MessagesStatus,
              private empresasService:EmpresasService) {

              this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.cargarListado()  
   }


  CerrarPopUp(){
   this.cerrarPopupDesbloqueo.emit();
  }

  changeCheckBoxesStatus(e: MatCheckboxChange) {
    if (e.checked) {
      Object.keys(this.checkboxStates).forEach(key => {
        this.checkboxStates[key] = true;
      })
    } else {
      Object.keys(this.checkboxStates).forEach(key => {
        this.checkboxStates[key] = false;
      })
    }
  }

  cargarListado(){
    this.isLoading=true;
    this.loading = true;
    this.empresasService.obtenerListaProveedores('')
    .subscribe(res => {
      this.isLoading=false;
       this.loading = false;
       this.dataProveedores = res;
       this.provBloqueados = this.dataProveedores.filter(
        state => state.Estado === 'Bloqueado'
      );
        this.provBloqueados.forEach(item => {
        this.checkboxStates[item.idEmpresa] = false
        });  
        
        this.dataSource = new MatTableDataSource(this.provBloqueados);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
    }, (err: HttpErrorResponse)=> {
      this.isLoading=false;
      this.loading = false;
      if (err.error instanceof ErrorEvent) {
        console.error("Error Event");
    } else {
        this.msgStatus.getMessage(err.status);            
    }
    Swal.fire({
      title: this.msgTitulos.Error,
      text: "Lista de proveedores no obtenida. "+this.msgStatus.message,
      type: "error",
      allowOutsideClick: false,
      heightAuto: false
    });
    });
  }

  Guardar(){

    this.datosEnviar=[];
    this.provBloqueados.forEach(item => {
      
      if  (this.checkboxStates[item.idEmpresa]){
       this.datosEnviar.push(
         {
          'usuario':this.user.Usuario,
          'idEmpresa': item.idEmpresa,
          'Estado':'A',  
         }
       )   
      } 
      });

      if (this.datosEnviar.length == 0) {
        Swal.fire({
          title: "Warning",
          text: "seleccione al menos 1 proveedor",
          type: "warning",
          allowOutsideClick: true,
          heightAuto: false
          })
          return;
      }
      this.loading = true;
      Swal.fire({
        title: 'Espere',
        text:'Guardando información',
        type:'info',
        allowOutsideClick:false,
        heightAuto: false
        });
        Swal.showLoading();
        this.empresasService.actualizarEmpresaBloqueo(this.datosEnviar)
        .subscribe(resp => {
        Swal.fire({
          title: "Éxito",
          text: "Desbloqueo realizado correctamente",
          type: "success",
          allowOutsideClick: false,
          heightAuto: false
        }).then(res =>{
          if (res.value == true ){
            this.cerrarPopupDesbloqueo.emit();
            this.loading = false;        
          }   
        });
        },(err: HttpErrorResponse)=> {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error("Error Event");
        } else {
          this.msgStatus.getMessage(err.status);            
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "Hubo un error. "+this.msgStatus.message ,
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        })
        });
  }

}
